export default function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}


//////////////////
// WEBPACK FOOTER
// /var/www/clients/client0/web6/deploy/releases/20230327134040/web/app/themes/metadieta/node_modules/@popperjs/core/lib/utils/rectToClientRect.js
// module id = 36
// module chunks = 0